import { registerModuleDataProvider } from '../../providers/CustomDataProvider';
import { Resources } from '../resource';
import { perpsV1SymbolsDataProvider } from './dataProvider';

// 注册 perps-v1-symbols 模块的数据提供者
export function initPerpsV1SymbolsDataProvider() {
  registerModuleDataProvider(Resources.perpsV1Symbols, perpsV1SymbolsDataProvider);
}

// 自动初始化
initPerpsV1SymbolsDataProvider();
